import * as React from 'react';

import type {
  SystemMessageWrapperContext as SystemMessageWrapperContextType
} from '../types';

const SystemMessageWrapperContext = React.createContext<SystemMessageWrapperContextType>({});

export default SystemMessageWrapperContext;
